module.exports = __webpack_public_path__ + "static/media/yash.2aa94ed0.jpg";